<template>
  <b-button @click="$emit('click', $event)" size="sm" variant="warning" v-b-tooltip.hover :title="showToolTip ? 'Восстановить' : ''"><i class="fa fa-undo"></i></b-button>
</template>

<script>

export default ({
  name: "button-undo",
  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  }
})
</script>
